import React, {useEffect/*, useState*/} from "react";
import {useDispatch, useSelector} from "react-redux";
import {withRouter} from "react-router-dom";
import {sharingPageReady} from "../../../actions/profileActions";
// import Button from "../../components/button";
import './index.css';

function Support (/* { history } */) {

    const profile = useSelector(state => state.profileReducer.getProfile);
    const dispatch = useDispatch();

    // Temporary Synchronization Delay Notice (uncomment if delay issues recur)
    /*
    const [showNotice, setShowNotice] = useState(true);

    if (showNotice) {
        return (
            <div className="support-notice-container">
                <div className="support-notice-card">
                    <h2 className="support-notice-title">Google Contacts Synchronization Delay</h2>
                    
                    <p className="support-notice-text">
                        Google Contacts is currently experiencing a temporary delay in reflecting contact updates and creations made within ContactsFlow™ for some accounts.
                    </p>
                    
                    <p className="support-notice-text">
                        If your account is affected by this synchronization delay, please rest assured that <strong>no action is required on your part</strong>. Our engineering team is actively resolving this issue, and it is expected to be fully resolved within the next 48 hours.
                    </p>

                    <div className="support-notice-actions">
                        <Button className="btn-primary" onClick={() => history.push('/')}>
                            Close
                        </Button>
                        <Button className="btn-outline-secondary" onClick={() => setShowNotice(false)}>
                            My request is about something else
                        </Button>
                    </div>
                </div>
            </div>
        );
    }
    */

    useEffect(() => {
        dispatch(sharingPageReady(true));
    }, [dispatch]);

    return (
        <iframe title="Contact Support form" className="support"
                src={`https://forms.zohopublic.com/stefnewland/form/CustomerSupportForm/formperma/g1U0Tws4TlaDzRX1swTV96UHb3ss524rovtwasjCGJo?SingleLine7=${profile.name}&email=${profile.email}&phone=${profile?.details?.phoneNumbers?.[0]?.number ?? ''}`}/>
    )
}

export default withRouter(Support);